// extracted by mini-css-extract-plugin
export default {"patient-btn":"patient-button_patient-btn__hQU30"};